import DOMPurify from 'dompurify'

interface PriceRow {
  value: string
}

interface Column {
  title: string
  rows: PriceRow[]
}

interface InsurancePriceTableProps {
  title: string
  subTitle?: string
  description?: string
  footerDescription?: string
  backgroundColor?: string
  columns: Column[]
}

export default function InsurancePriceTable({
  title,
  subTitle,
  description,
  footerDescription,
  backgroundColor = '#FFFFFF',
  columns,
}: InsurancePriceTableProps) {
  return (
    <section
      className="w-full max-w-[390px] mx-auto px-4 py-6"
      style={{ backgroundColor }}
    >
      <h2 className="text-sm text-[#101010] font-semibold mb-2">{title}</h2>
      {subTitle && (
        <h3 className="text-sm font-medium text-gray-700 mb-2">{subTitle}</h3>
      )}
      {description && (
        <p
          className="text-sm text-[#616161] [&_a]:underline [&_a]:font-semibold mb-4"
          suppressHydrationWarning
          dangerouslySetInnerHTML={{
            __html:
              typeof DOMPurify?.sanitize === 'function'
                ? DOMPurify.sanitize(description)
                : description,
          }}
        />
      )}

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-white">
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="border-b border-[#E1E0DF] first:pl-0 w-4 pl-3 pr-3 py-2 text-left text-xs text-[#101010] font-normal"
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {columns[0].rows.map((_, rowIdx) => (
              <tr
                key={rowIdx}
                className="last:border-none border-b border-[#E1E0DF]"
              >
                {columns.map((col, colIdx) => (
                  <td
                    key={colIdx}
                    className="pl-[1px] pr-2 py-3 text-xs text-[#101010] font-normal"
                  >
                    {col.rows[rowIdx]?.value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {footerDescription && (
        <div className="mt-4 space-y-1">
          {footerDescription.split('\n').map((line, idx) => (
            <p
              key={idx}
              className="text-xs text-[#616161] font-normal [&_a]:underline [&_a]:font-semibold"
              suppressHydrationWarning
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(line),
              }}
            />
          ))}
        </div>
      )}
    </section>
  )
}
